module.exports = __webpack_public_path__ + "static/media/bookizon-logo.b0b50384.svg";